/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Ad_Render_TtsInputs */

const en_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Render Text-to-Speech`)
};

const fr_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendre le texte en synthese vocale`)
};

const de_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-zu-Sprache-Wiedergabe`)
};

const it_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma testo in voce`)
};

const ru_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование текста в речь`)
};

const es_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar texto a voz`)
};

const zh_cn2_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染文本转语音`)
};

const ja_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト読み上げのレンダリング`)
};

const hi_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट-टू-स्पीच रेंडर करें`)
};

const pt_pt2_shortcut_keys_name_ad_render_tts = /** @type {(inputs: Shortcut_Keys_Name_Ad_Render_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar texto para fala`)
};

/**
* | output |
* | --- |
* | "Render Text-to-Speech" |
*
* @param {Shortcut_Keys_Name_Ad_Render_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_ad_render_tts = /** @type {((inputs?: Shortcut_Keys_Name_Ad_Render_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Ad_Render_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "de") return de_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "it") return it_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "es") return es_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_ad_render_tts(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_ad_render_tts(inputs)
	return en_shortcut_keys_name_ad_render_tts(inputs)
});